import useEntity from '../../../recoil/useEntity/useEntity'
import { ILibraryGroup } from '@/pages/Library/libraryGroups.types.ts'
import libraryGroupsAtom from '@/pages/Library/libraryGroups.atom.ts'
import libraryGroupsApi from '@/pages/Library/libraryGroups.api.ts'

const useLibraryGroup = (id: ILibraryGroup['id']) => {
  const { entity, loading } = useEntity({
    atom: libraryGroupsAtom,
    entityId: id,
    itemFetcher: libraryGroupsApi.getGroup,
  })

  return { loading, group: entity }
}

export default useLibraryGroup
